import React from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function PolicyTypeBadge({ layerStyle, policyType }) {
  return (
    <Flex
      _hover={{ cursor: 'default' }}
      alignItems="center"
      borderRadius="sm"
      height="32px"
      justifyItems="center"
      layerStyle={layerStyle}
      p="7px"
      textStyle="bodySm500"
      width="auto"
    >
      {policyType}
    </Flex>
  );
}

PolicyTypeBadge.propTypes = {
  policyType: PropTypes.string,
  layerStyle: PropTypes.string
};

export default PolicyTypeBadge;
